var render, staticRenderFns
import script from "./ToggleSkeleton.vue?vue&type=script&lang=ts&"
export * from "./ToggleSkeleton.vue?vue&type=script&lang=ts&"
import style0 from "./ToggleSkeleton.vue?vue&type=style&index=0&id=dc941e14&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports